import { TRootState } from '../@types/redux';

export const selectModalState = ( state: TRootState ) =>state.states.statesModalIsOpen

export const selectIsUpdateState = ( state: TRootState ) =>state.states.isUpdateState

export const selectStateForUpdate = ( state: TRootState ) =>state.states.stateForUpdate

export const selectStatesRefresh = ( state: TRootState ) =>state.states.refreshTableStates